import { ApiBase } from '../api-base'

export class ImportServices extends ApiBase {
  constructor () {
    super({
      resource: '/api/v1/imports',
      name: 'imports',
      successPath: '/imports'
    })
  }

  sendFile ({ type, body }) {
    return this.api.post(`${this.resource}/${type}`, body)
  }
}
